import { useEffect, useState } from "react";

export function useCopyAction(text: string) {
  const [copyKey, setCopyKey] = useState(0);
  const [didJustCopy, setDidJustCopy] = useState(false);

  useEffect(() => {
    if (!copyKey) {
      return;
    }

    setDidJustCopy(true);

    const timeout = setTimeout(() => {
      setDidJustCopy(false);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [copyKey]);

  const onCopy = () => {
    void navigator.clipboard.writeText(text);
    setCopyKey((key) => key + 1);
  };

  return {
    didJustCopy,
    onCopy,
  };
}
